
import React from 'react';
import AdminRolesManager from '@/components/admin/roles/AdminRolesManager';

const AdminRolesManagement: React.FC = () => {
  return <AdminRolesManager />;
};

export default AdminRolesManagement;
